import { BaseValidationRule, IValidateable } from '@aurelia/validation';

export class ValidNumberPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return value === null ||
    value === undefined ||
    value === "" ||
    !isNaN(Number(value));
  }
}
